import React from "react";

function HomeScreenHowToUse(props) {
  return (
    <div className="container rounded-2" style={{ marginTop: "6rem" }}>
      <div
        className="d-flex justify-content-center p-5 mx-auto"
        style={{
          backgroundImage: "url(./images/bg_section.png)",
          width: "368px",
          height: "437px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "auto",
        }}
      >
        <div className="my-auto text-end me-5">
          <img
            loading="lazy"
            src="./images/question.png"
            style={{ width: "100px", height: "100px" }}
            alt="question"
          />
        </div>
        <div className="text-start ms-5 my-auto">
          <div className="d-flex">
            <img
              loading="lazy"
              src="./images/tick.png"
              alt="tick"
              style={{ width: "20px", height: "20px" }}
            />
            <h6 className="ms-2 fs-6">{props.steps.step1}</h6>
          </div>

          <div className="d-flex mt-3">
            <img
              loading="lazy"
              src="./images/tick.png"
              alt="tick"
              style={{ width: "20px", height: "20px" }}
            />
            <h6 className="ms-2 fs-6">{props.steps.step2}</h6>
          </div>

          <div className="d-flex mt-3">
            <img
              loading="lazy"
              src="./images/tick.png"
              alt="tick"
              style={{ width: "20px", height: "20px" }}
            />
            <h6 className="ms-2 fs-6">{props.steps.step3}</h6>
          </div>

          <div className="d-flex mt-3">
            <img
              loading="lazy"
              src="./images/tick.png"
              alt="tick"
              style={{ width: "20px", height: "20px" }}
            />
            <h6 className="ms-2 fs-6">{props.steps.step4}</h6>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeScreenHowToUse;
